<template>
  <div
    class="mb-4 pa-4"
    style="
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
      width: 100%;
      position: relative;
    "
  >
    <!-- Generating state -->
    <template v-if="convertToPosts === 'generating'">
      <div class="d-flex align-start mb-2" style="gap: 8px">
        <v-progress-circular
          indeterminate
          size="18"
          width="2"
          color="#7c3aed"
        />
        <p style="font-size: 11pt; font-weight: 600; color: #18181b; margin: 0">
          Generating posts...
        </p>
      </div>
      <p style="font-size: 10pt; font-weight: 400; color: #71717a" class="mb-0">
        Your knowledge items are being converted. You can close and continue
        working — we'll let you know when they're ready.
      </p>
    </template>

    <!-- Done state -->
    <template v-if="convertToPosts === 'done'">
      <v-btn
        icon
        variant="text"
        size="x-small"
        style="position: absolute; top: 8px; right: 8px"
        @click="dismiss"
      >
        <v-icon size="16" color="#a1a1aa">mdi-close</v-icon>
      </v-btn>
      <div class="d-flex align-start mb-2" style="gap: 8px">
        <v-icon size="18" color="#16a34a">mdi-check-circle</v-icon>
        <p style="font-size: 11pt; font-weight: 600; color: #18181b; margin: 0">
          Posts generated!
        </p>
      </div>
      <p style="font-size: 10pt; font-weight: 400; color: #71717a" class="mb-3">
        Your posts are ready to review.
      </p>
      <v-btn
        color="#18181b"
        variant="flat"
        size="small"
        block
        class="text-none font-weight-medium"
        style="border-radius: 6px; letter-spacing: 0"
        @click="viewPosts"
      >
        <v-icon size="16" class="mr-2">mdi-arrow-right</v-icon>
        View posts
      </v-btn>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      convertToPosts: (state) => state.loading.convertToPosts,
      convertedItemUids: (state) => state.loading.convertedItemUids,
      knowledgeItems: (state) => state.knowledge.items,
    }),
  },
  methods: {
    dismiss() {
      this.$store.commit("setConvertToPosts", "idle");
      this.$store.commit("setConvertedItemUids", []);
    },
    viewPosts() {
      const postIds = this.knowledgeItems
        .filter((item) => this.convertedItemUids.includes(item.uid))
        .flatMap((item) => item.posts || []);
      this.$store.commit("setQuery", {
        status: "all",
        category: null,
        recurring: null,
        search: null,
        knowledge: postIds,
      });
      this.$store.commit("setConvertToPosts", "idle");
      this.$store.commit("setConvertedItemUids", []);
      this.$router.push("/library");
    },
  },
};
</script>
